namespace advisorop.components.common {

    class TypeaheadMultiselectController {
        blur: boolean = false;
        focused: boolean = false;
        filteredItems: Array<any> = [];
        selPos: number = 0;
        itemSearch: string;
        placeHolderText = "Security, Product or Manager name...";
        currentPlaceHolderText = this.placeHolderText;

        // bindings
        displayName: string;
        displayTag: string;
        onSearch: any;
        list: Array<any> = [];
        returnList: Array<any> = [];
        resetSearch: boolean;
        disableInput: boolean;

        static $inject = ["$scope"];
        constructor(private $scope: ng.IScope) {
            $scope.$watch("vm.resetSearch", (newValue, oldValue) => {
                if (newValue && !oldValue) {
                    this.returnList = [];
                    this.currentPlaceHolderText = this.placeHolderText;
                }
            });
        }

        focusIn(): void {
            if (!this.focused) {
                this.focused = true;
                this.blur = false;
                this.selPos = 0;
            }
        };

        focusOut($event): void {
            this.itemSearch = "";
            if (!this.blur) {
                this.focused = false;
            } else {
                //console.log($event);
                $event.originalEvent.srcElement.focus()
                this.blur = false;
            }
        };

        mouseLeave(): void {
            this.focused = false;
        }

        getDisplayItem = function (item) {
            return item[this.displayName];
        };

        getDisplayTag = function (item) {
            return item[this.displayTag];
        };

        addItem = function (item) {
            if (item) {
                this.returnList.push(item);
                this.itemsearch = "";
                this.blur = true;
                if (this.selPos >= this.filteredItems.length - 1) {
                    this.selPos--; // To keep hover selection
                }
                //this.ngModel.$setViewValue(this.list);
            }
            this.currentPlaceHolderText = this.returnList.length == 0 ? this.placeHolderText : ""
        };

        removeItem = function (item) {
            this.returnList.splice(this.returnList.indexOf(item), 1);
            this.currentPlaceHolderText = this.returnList.length == 0 ? this.placeHolderText : ""
            //this.ngModel.$setViewValue(this.list);
        };

        hover = function (index) {
            this.selPos = index;
        };

        keyPress = function (evt) {
            //console.log(evt.keyCode);
            var keys = {
                38: 'up',
                40: 'down',
                8: 'backspace',
                13: 'enter',
                9: 'tab',
                27: 'esc'
            };

            switch (evt.keyCode) {
                case 27:
                    this.focusOut();
                    break;
                case 13:
                    if (this.selPos > -1) {
                        this.addItem(this.filteredItems[this.selPos]);
                    }
                    this.valuesSelected();
                    break;
                case 8:
                    if (!this.itemsearch || this.itemsearch.length == 0) {
                        if (this.returnList.length > 0) {
                            this.returnList.pop();
                        }
                    }
                    break;
                case 38:
                    if (this.selPos > 0) {
                        this.selPos--;
                    }
                    break;
                case 40:
                    if (this.selPos < this.filteredItems.length - 1) {
                        this.selPos++;
                    }
                    break;
                default:
                    this.selPos = 0;
                    this.focusIn();
            }
        };

        onInputChange(): void {
            this.onSearch({ searchTerm: this.itemSearch });
            this.focused = true;
//            this.hideList = false;
        }

        $onInit(): void {
        };

        $onChanges(evt) {
            //console.log(evt);
            if (evt.resetSearch.currentValue == true && evt.resetSearch.previousValue == false) {
                this.returnList = [];
            }
        }
    }



    class TypeaheadMultiselect implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                displayName: "@",
                displayTag: "@",
                list: "<",
                returnList: "=",
                onSearch: "&",
                resetSearch: "<",
                disableInput: "<",
            };
            this.controller = TypeaheadMultiselectController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/typeahead-multiselect.html';
        }
    }
    angular.module(Constants.APP).component("typeaheadMultiselect", new TypeaheadMultiselect());

}